import { render, staticRenderFns } from "./EarningTable.vue?vue&type=template&id=0fa27214"
import script from "./EarningTable.vue?vue&type=script&lang=js"
export * from "./EarningTable.vue?vue&type=script&lang=js"
import style0 from "./EarningTable.vue?vue&type=style&index=0&id=0fa27214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports